import React from 'react';
import {LocalDocumentContentStatus} from "../../../models/local-documents.models";
import {useTranslation} from "react-i18next";
import {DigitizedDocumentStatusWrapper, StatusDot, StyledStatusText} from "./DigitizedDocumentStatus.styled";

interface DigitizedDocumentStatusProps {
    status: LocalDocumentContentStatus;
}

const DigitizedDocumentStatus = ({status}: DigitizedDocumentStatusProps) => {
    const {t} = useTranslation();

    if (!status) return <React.Fragment />;

    return (
        <DigitizedDocumentStatusWrapper $status={status}>
            {status !== 'ERROR' && <StatusDot $status={status} />}

            <StyledStatusText $status={status}>
                {t(`documentsDigitization.status.${status}`)}
            </StyledStatusText>
        </DigitizedDocumentStatusWrapper>
    );
};

export default DigitizedDocumentStatus;